import styled from "styled-components"

const LimitInfo = styled.div`
  width: 100%;
  padding: ${({theme}) => theme.spacing.one};
  border-radius: 3px;
  background-color: ${({theme}) => theme.colors.greys.lightest};
  margin-bottom: 10px;
`

export default LimitInfo
